import { createAction } from 'redux-actions';

export const MODULE_NAME = 'LTI_PLANS';

export default {
  MODULE_NAME,
};

export const createPrefixedAction = (type) => createAction(`${MODULE_NAME}/${type}`);
